const icon_box     = {
    icon_box:      <svg
    xmlns="http://www.w3.org/2000/svg"
    width="512"
    height="512"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 512 512"
  >
    <g xmlns="http://www.w3.org/2000/svg" fill="red">
      <path
        d="M236.94 237.109l-230-96.842C3.645 138.879 0 141.299 0 144.875v258.899a15.998 15.998 0 0010.058 14.855l223.085 89.234c3.284 1.314 6.857-1.105 6.857-4.642V241.717a5 5 0 00-3.06-4.608zM257.94 209.596l222.315-93.606c3.996-1.682 4.103-7.306.174-9.139L262.766 5.275a16.002 16.002 0 00-13.532 0L31.571 106.851c-3.929 1.833-3.822 7.457.174 9.139l222.315 93.606c1.24.523 2.64.523 3.88 0zM272 241.717v261.504c0 3.537 3.573 5.956 6.857 4.642l223.085-89.234A16 16 0 00512 403.774V144.875c0-3.576-3.645-5.996-6.94-4.608l-230 96.842a5 5 0 00-3.06 4.608z"
        data-original="#000000"
      ></path>
    </g>
  </svg>
}

export default icon_box;